import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Search, BookOpen, Loader2 } from "lucide-react";

const CATS = ["All", "National", "National Board", "International", "Alternative", "Modern", "Self-Directed", "Traditional"];

export default function CurriculumExplorer() {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/curricula").then((r) => setList(r.data));
  }, []);

  const filtered = (list || []).filter((c) => {
    const catOk = cat === "All" || c.category === cat;
    const qOk = !q || c.name.toLowerCase().includes(q.toLowerCase()) || c.description.toLowerCase().includes(q.toLowerCase());
    return catOk && qOk;
  });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="max-w-3xl mb-10">
        <div className="overline mb-3">Curriculum Explorer</div>
        <h1 className="text-4xl sm:text-5xl font-semibold text-brand-blue leading-tight">Every path, explained clearly.</h1>
        <p className="mt-4 text-lg text-brand-muted">From NCERT to IB, Montessori to Unschooling — see how each curriculum shapes childhood.</p>
      </div>

      {/* filters */}
      <div className="flex flex-col md:flex-row gap-3 md:items-center mb-8">
        <div className="relative flex-1">
          <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-brand-muted" />
          <input
            data-testid="curriculum-search-input"
            className="field pl-11"
            placeholder="Search curricula..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button
              key={c}
              data-testid={`curriculum-filter-${c.toLowerCase().replace(/\s+/g,'-')}`}
              onClick={() => setCat(c)}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-all ${
                cat === c ? "bg-brand-blue text-white border-brand-blue" : "bg-white text-brand-blue border-brand-border hover:border-brand-blue"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {!list ? (
        <div className="py-16 text-center"><Loader2 className="animate-spin mx-auto text-brand-green" /></div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((c) => (
            <Link
              key={c.id}
              to={`/curriculum/${c.id}`}
              data-testid={`curriculum-card-${c.id}`}
              className="surface surface-hover p-6 group"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-11 h-11 rounded-xl bg-brand-green-soft text-brand-green flex items-center justify-center"><BookOpen size={20} /></div>
                <span className="chip-blue">{c.category}</span>
              </div>
              <h3 className="text-xl font-semibold text-brand-blue">{c.name}</h3>
              <p className="mt-2 text-sm text-brand-muted line-clamp-3">{c.description}</p>
              <div className="mt-4 flex flex-wrap gap-2 text-xs">
                <span className="chip">Ages {c.age_range}</span>
                <span className="chip-orange">{c.cost}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
      {list && filtered.length === 0 && <p className="text-center text-brand-muted py-12">No curricula match your filters.</p>}
    </div>
  );
}
